/** Un libellé du serveur : un texte déjà traduit, ou une étiquette par langue (`{ fr, en, nl… }`). */
export type LabelValue = string | Record<string, string | undefined> | null | undefined;

/** Le texte d'un libellé dans la langue de l'app, le français puis l'anglais à défaut ; vide sans libellé. */
export function labelText(value: LabelValue, lang: string | null | undefined): string {
  if (!value) return '';
  if (typeof value === 'string') return value;
  const code = (lang || 'fr').toLowerCase();
  return value[code] ?? value['fr'] ?? value['en'] ?? '';
}
